import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import ReactDOM from 'react-dom'

import { useIsMobile } from '@/utils/useMobile'

import { useMarket } from '@/utils/multi-markets/context'

import PopupBottom from './PopupBottom'
import { usePopup } from './hooks/usePopup'

export default function PopupBottomView() {
  const { t: translatePopups } = useTranslation('popups')
  const { isPopupOpen, setIsPopupOpen } = usePopup({
    key: 'isPopupOpen',
    isSession: true
  })

  const router = useRouter()
  const { isMobile } = useIsMobile()
  const { market } = useMarket()

  const isEidPopupAvailable =
    market === 'ae' && new Date() < new Date('2025-04-07')

  const popupElement = isPopupOpen && (
    <PopupBottom
      mainText={
        isEidPopupAvailable
          ? translatePopups('popup.text.eidTitleNoSpace')
          : isMobile
          ? translatePopups('popup.text.space')
          : translatePopups('popup.text.nospace')
      }
      secondaryTextOnImage={translatePopups(
        isEidPopupAvailable
          ? isMobile
            ? 'popup.text.eidDescription'
            : 'popup.text.eidDescriptionNoSpace'
          : 'popup.text.description'
      )}
      image={
        isEidPopupAvailable
          ? isMobile
            ? 'https://s3.eu-central-1.amazonaws.com/cdn.naviparking.com/digital_parking/landing/eidPopupMobile.webp'
            : 'https://s3.eu-central-1.amazonaws.com/cdn.naviparking.com/digital_parking/landing/eidDesktopPopup.webp'
          : isMobile
          ? 'https://s3.eu-central-1.amazonaws.com/cdn.naviparking.com/digital_parking/landing/popup_mobile.png'
          : 'https://s3.eu-central-1.amazonaws.com/cdn.naviparking.com/digital_parking/landing/popup_1.png'
      }
      onClose={() => {
        setIsPopupOpen(false)
        sessionStorage.setItem('isPopupOpen', 'true')
      }}
      onDiscover={() => {
        isEidPopupAvailable
          ? router.push({
              pathname: '/parkings/dubai/holiday-inn-dubai-park-fly'
            })
          : router.push({
              pathname: '/parking-search',
              query: {
                service: 'PARK_AND_FLY'
              }
            })
        setIsPopupOpen(false)
        sessionStorage.setItem('isPopupOpen', 'true')
      }}
    />
  )
  return typeof window !== 'undefined' ? (
    document.getElementById('popup-wrapper') &&
      ReactDOM.createPortal(
        popupElement,
        document.getElementById('popup-wrapper')!
      )
  ) : (
    <></>
  )
}
